export enum PaymanyTypeEnum {
  SIMPLE_PAYMENT = 'SIMPLE_PAYMENT',
  DOCUMENT_PAYMENT = 'DOCUMENT_PAYMENT',
  DEFERRED_PAYMENT_SIGN = 'DEFERRED_PAYMENT_SIGN',
}
